// extracted by mini-css-extract-plugin
export default {"tabListItem":"Tab_tabListItem__qwJvL","tabListActive":"Tab_tabListActive__sOHHJ"};